import { useQuery } from "@tanstack/react-query";
import {
	VisitDetailFilters,
	VisitDetailResponse,
	reportsService,
} from "../../services/reports.service";

// SIMS-5663 — Visit Detail (paginated). Refetches automatically on any filter
// or page change (all in the queryKey); disabled until a program is selected.
const useVisitDetail = (filters: VisitDetailFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<VisitDetailResponse>({
		queryKey: [
			"reports-visit-detail",
			filters.accountId,
			filters.programId,
			filters.orgUnitIds ?? "",
			filters.payerIds ?? "",
			filters.groupLabelIds ?? "",
			filters.providerId ?? "",
			filters.startDate ?? "",
			filters.endDate ?? "",
			filters.cin ?? "",
			filters.pageNumber ?? 0,
			filters.pageSize ?? 25,
		],
		queryFn: () => reportsService.getVisitDetail(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useVisitDetail;
